#import "../fragments/materialized-email-sequence-fragment.graphql"

query GetMaterializedEmailSequence($emailSequenceTemplateId: ID!, $entityId: ID!) {
    materializedEmailSequenceTemplate(
        emailSequenceTemplateId: $emailSequenceTemplateId
        entityId: $entityId
    ) {
        ...MaterializedEmailSequence
    }
}
